module.exports = __webpack_public_path__ + "media/src/assets/images/logo-4dbbacd2b2a1f0fd2f7939b1e1c3993b.svg";